// extracted by mini-css-extract-plugin
export var breadcrumb = "_4-0";
export var breadcrumbArrow = "_4-1";